import defaultApi from '@/utils/request';

export default {
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentResDiagRecord/Get',
      params,
    });
  },
  GetResTypeCount(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentResDiagRecord/GetResTypeCount',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      url: 's7x_StudentResDiagRecord/Add',
      method: 'post',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      url: 's7x_StudentResDiagRecord/Update',
      method: 'post',
      data,
    });
  },
};
